// ripple.js — EIN delegierter pointerdown-Listener für alle .vc-btn/.vc-icon-btn/.vc-fab/.vc-state.
import { reducedMotion } from './dom.js';

const SEL = '.vc-btn, .vc-icon-btn, .vc-fab, .vc-state';
let installed = false;

export function installRipple(root = document) {
  if (installed) return;
  installed = true;
  root.addEventListener('pointerdown', (e) => {
    if (e.button !== 0 || reducedMotion()) return;
    const host = e.target.closest && e.target.closest(SEL);
    if (!host || host.disabled || host.getAttribute('aria-disabled') === 'true' || host.dataset.noRipple != null) return;
    const r = host.getBoundingClientRect();
    const size = Math.hypot(Math.max(e.clientX - r.left, r.right - e.clientX), Math.max(e.clientY - r.top, r.bottom - e.clientY)) * 2;
    const span = document.createElement('span');
    span.className = 'vc-ripple';
    span.style.cssText = `width:${size}px;height:${size}px;left:${e.clientX - r.left - size / 2}px;top:${e.clientY - r.top - size / 2}px`;
    host.appendChild(span);
    const done = () => span.remove();
    span.addEventListener('animationend', done, { once: true });
    setTimeout(done, 1200);
  }, { passive: true });
}
